import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-slk',
  templateUrl: './slk.component.html',
  styleUrls: ['./slk.component.scss']
})
export class SlkComponent implements OnInit {

  page: Object;
  
  constructor(private contentService: ContentService) { 
  }

  ngOnInit() {
    this.page = this.contentService.pages['slk'];
  }

}
